import React from 'react';
import PropTypes from 'prop-types';

class Select extends React.Component {
  constructor(props) {
    super(props);
    this.onSelect = typeof props.onSelect === 'function' ? props.onSelect : () => {};

    this.state = {
      val: props.value
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== this.state.val) {
      this.setState({ val: this.props.value });
    }
  }

  updateValue(value, target) {
    this.setState({ val: value });
    this.onSelect(value, target);
  };

  render() {
    return (
      <>
        <select className={'select-box form-control ' + this.props.className} ref={this.props.ref} value={this.state.val} onChange={(e) => this.updateValue(e.target.value, e.target)} disabled={this.props.disabled}>
          {this.props.empty && <option value={this.props.empty.value}>{this.props.empty.text}</option>}
          {this.props.options.map((option, i) => (
            <option value={option.value} key={i}>
              {option.text}
            </option>
          ))}
        </select>
      </>
    );
  }
}

Select.propTypes = {
  className: PropTypes.string,
  ref: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  empty: PropTypes.object,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default Select;